import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from '@emailjs/browser';
import './sarah.styles.css';
import pixel_heart from '../../assets/heart.png';

const Sarah = () => {
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
    const [showMathChallenge, setShowMathChallenge] = useState(false);
    const [mathAnswer, setMathAnswer] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const recaptchaRef = useRef(null);

    const handleCaptchaChange = (token) => {
        if (token) {
            setCaptchaVerified(true);
            setErrorMessage('');
        } else {
            setCaptchaVerified(false);
        }
    };

    const handleCaptchaExpired = () => {
        setCaptchaVerified(false);
    };

    // Send SMS via EmailJS Carrier Gateway
    const sendTextNotification = () => {
        const serviceId = 'service_x51ch5i';
        const templateId = 'template_c31wy4e';
        const publicKey = 'fmYxZMcoQtqdzZaXb';

        const templateParams = {
            message: 'Sarah said YES on your website! ❤️',
        };

        emailjs.send(serviceId, templateId, templateParams, publicKey)
            .then((response) => {
                console.log('SMS notification sent successfully!', response.status, response.text);
            })
            .catch((error) => {
                console.error('Failed to send SMS notification:', error);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedOption) {
            setErrorMessage('Please select Yes or No!');
            return;
        }

        if (!captchaVerified) {
            setErrorMessage('Please complete the reCAPTCHA verification first!');
            return;
        }

        setErrorMessage('');

        if (selectedOption === 'yes') {
            sendTextNotification();
            setSubmitted(true);
        } else if (selectedOption === 'no') {
            setShowAreYouSureModal(true);
        }
    };

    const handleAreYouSureNo = () => {
        setShowAreYouSureModal(false);
        setSelectedOption(null);
        setCaptchaVerified(false);
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
        }
    };

    const handleAreYouSureYes = () => {
        setShowAreYouSureModal(false);
        setShowMathChallenge(true);
    };

    const handleCloseMathChallenge = () => {
        setShowMathChallenge(false);
        setSelectedOption(null);
        setCaptchaVerified(false);
        setMathAnswer('');
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
        }
    };

    const handleMathSubmit = (e) => {
        e.preventDefault();
        if (mathAnswer.trim() === '80') {
            alert('Math correct... but you should still click Yes! ;)');
            setShowMathChallenge(false);
            setSelectedOption('yes');
        } else {
            alert('Incorrect! Try again, or maybe just click Yes? ❤️');
        }
    };

    if (submitted) {
        return (
            <div className="sarah-container">
                <div className="heart-3d-container">
                    <img src={pixel_heart} alt="Rotating Heart" className="heart-3d-img" />
                </div>
                <h1 className="sarah-heading">Yay! ❤️</h1>
                <p className="sarah-subtext">You made my day!! :)</p>
            </div>
        );
    }

    return (
        <div className="sarah-container">
            {/* 3D Rotating Heart */}
            <div className="heart-3d-container">
                <img src={pixel_heart} alt="Rotating Heart" className="heart-3d-img" />
            </div>

            <h1 className="sarah-heading">Hey Sarah! Will you be my girlfriend?</h1>

            <form onSubmit={handleSubmit} className="sarah-form">
                <div className="button-group">
                    <button
                        type="button"
                        className={`choice-btn yes-btn ${selectedOption === 'yes' ? 'active' : ''}`}
                        onClick={() => setSelectedOption('yes')}
                    >
                        Yes ❤️
                    </button>
                    <button
                        type="button"
                        className={`choice-btn no-btn ${selectedOption === 'no' ? 'active' : ''}`}
                        onClick={() => setSelectedOption('no')}
                    >
                        No 💔
                    </button>
                </div>

                {/* Google reCAPTCHA v2 Checkbox & Picture Grid */}
                <div className="captcha-wrapper">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" // Insert your Site Key here
                        onChange={handleCaptchaChange}
                        onExpired={handleCaptchaExpired}
                    />
                </div>

                {errorMessage && <p className="error-text">{errorMessage}</p>}

                <button type="submit" className="submit-btn">
                    Submit
                </button>
            </form>

            {/* "Are You Sure?" Modal */}
            {showAreYouSureModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Are you sure? 🥺</h2>
                        <p>Do you really want to say no?</p>
                        <div className="modal-buttons">
                            <button className="modal-btn" onClick={handleAreYouSureNo}>
                                No (Go Back)
                            </button>
                            <button className="modal-btn confirm" onClick={handleAreYouSureYes}>
                                Yes (I am sure)
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Math Challenge Modal */}
            {showMathChallenge && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <button
                            className="modal-close-btn"
                            onClick={handleCloseMathChallenge}
                        >
                            ×
                        </button>
                        <h2>Math Challenge 🧮</h2>
                        <p>Solve this calculus problem to confirm "No":</p>
                        <p className="math-equation">Evaluate: &int;<sub>0</sub><sup>4</sup> (x<sup>3</sup> + 2x) dx</p>
                        <form onSubmit={handleMathSubmit}>
                            <input
                                type="number"
                                value={mathAnswer}
                                onChange={(e) => setMathAnswer(e.target.value)}
                                placeholder="Enter answer"
                                className="math-input"
                                required
                            />
                            <button type="submit" className="submit-btn">
                                Verify Answer
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sarah;